import type { SVGProps } from 'react';

export const Cancel = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'cancel'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <rect height="32" width="32" x="0" y="0" />
      <g fill={props.fill} fillRule="nonzero">
        <path d="M21.9787342,15.9837975 L31.5382278,6.4243038 C32.1539241,5.80860759 32.1539241,4.77164557 31.5382278,4.1235443 L27.8116456,0.461772152 C27.1959494,-0.153924051 26.1589873,-0.153924051 25.5108861,0.461772152 L15.9837975,9.98886076 L6.4243038,0.461772152 C5.80860759,-0.153924051 4.77164557,-0.153924051 4.1235443,0.461772152 L0.461772152,4.15594937 C-0.153924051,4.77164557 -0.153924051,5.80860759 0.461772152,6.45670886 L9.98886076,15.9837975 L0.461772152,25.5432911 C-0.153924051,26.1589873 -0.153924051,27.1959494 0.461772152,27.8440506 L4.15594937,31.5382278 C4.77164557,32.1539241 5.80860759,32.1539241 6.45670886,31.5382278 L15.9837975,21.9787342 L25.5432911,31.5382278 C26.1589873,32.1539241 27.1959494,32.1539241 27.8440506,31.5382278 L31.5382278,27.8440506 C32.1539241,27.2283544 32.1539241,26.1913924 31.5382278,25.5432911 L21.9787342,15.9837975 Z" />
      </g>
    </g>
  </svg>
);
